import { PropsWithChildren} from "react";

import { FormItem, FormItemProps } from "@/stories/components/Form/FormItem/FormItem";
import { Label } from "@/stories/components/Form/FormItem/Label";

export  type FormIemGroupProps = {
  title?: string,
  className?: string
  hideOptionnal?: boolean
  hideLabel?: boolean
} & PropsWithChildren & FormItemProps

export const FormIemGroup = ({title, hideOptionnal, hideLabel, className, children, ...props}: FormIemGroupProps) => {
  return (
    <FormItem className={className} {...props}>
      {title ? <Label type="span" label={title} hideOptionnal={hideOptionnal} hideLabel={hideLabel}/> : null }
      {children}
    </FormItem>
  )
}